import React from 'react';
import PropTypes from 'prop-types';
import moment from 'moment';
import { Table, TBody, TR, TD } from 'oy-vey';
import Layout from '../layouts/Layout';
import Header from '../modules/Header';
import Footer from '../modules/Footer';
import EmptySpace from '../modules/EmptySpace';
import { checkInData } from '../../../helpers/timeHelper';
import { url, sitename } from '../../../config';

class ViewingRequest extends React.Component {

  /* static propTypes = {
    content: PropTypes.shape({
      reservationId: PropTypes.number.isRequired,
      threadId: PropTypes.number.isRequired,
      confirmationCode: PropTypes.number.isRequired,
      guestName: PropTypes.string.isRequired,
      guestLastName: PropTypes.string.isRequired,
      guestLocation: PropTypes.string.isRequired,
      guestProfilePic: PropTypes.string.isRequired,
      guestJoinedDate: PropTypes.string.isRequired,
      checkIn: PropTypes.string.isRequired,
      checkOut: PropTypes.string.isRequired,
      guests: PropTypes.number.isRequired,
      allowedCheckInTime: PropTypes.string.isRequired,
      allowedCheckOutTime: PropTypes.string.isRequired,
    }).isRequired
  }; */

  render() {
    const textStyle = {
      color: '#484848',
      backgroundColor: '#F7F7F7',
      fontFamily: 'Arial',
      fontSize: '16px',
      padding: '10px',
      textAlign: 'center'
    };

    const bookingTitle = {
      paddingBottom: '25px',
      fontWeight: 'bold',
      fontSize: '40px',
      lineHeight: '48px',
      margin: '0',
      padding: '0',
      textAlign: 'center'
    }

    const { content: { listingTitle, name, companyName, email, phoneNumber, preferredDate, message, logo } } = this.props;

    let preferredDateDate = new Date(preferredDate);
    let preferredDateString = preferredDateDate.toDateString();

    return (
      <Layout>
        <Header color="#D85B5F" backgroundColor="#F7F7F7" logo={logo} />
        <div>
          <Table width="100%" >
            <TBody>
              <TR>
                <TD style={textStyle}>
                  <EmptySpace height={20} />
                  <h1 style={bookingTitle}>New Viewing Request</h1>
                  <EmptySpace height={20} />
                  <div>
                    <span>Great News! You have a viewing request from {name}{companyName && <span> ({companyName})</span>}</span>
                  </div>
                  <EmptySpace height={20} />
                  <div>
                    <span>{name} would like to see your location <strong>{listingTitle}</strong> on <strong>{preferredDateString}</strong></span>
                  </div>
                  {
                  message && <React.Fragment><EmptySpace height={10} />
                  <div>
                    <span>They left the following message: {message}</span>
                  </div></React.Fragment>
                  }
                  <EmptySpace height={10} />
                  <div>
                    <span>Please get in touch at your earliest convenience:</span>
                  </div>
                  <EmptySpace height={10} />
                  <div>
                    <span>Telephone: <a href={"tel:" + phoneNumber}>{phoneNumber}</a></span><br />
                    <span>Email: <a href={"mailto:" + email}>{email}</a></span>
                  </div>
                  <EmptySpace height={40} />
                  <div>
                    Thank you,<br />
                    The {sitename} Team
                  </div>
                </TD>
              </TR>
            </TBody>
          </Table>
          <EmptySpace height={50} />
        </div>
        <Footer />
        <EmptySpace height={20} />
      </Layout>
    );
  }

}

export default ViewingRequest;


// WEBPACK FOOTER //
// src/core/email/template/ViewingRequest.js